import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { LocalStorageService } from './storage/local-storage.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GateWayService {
  private platformId = inject(PLATFORM_ID);
  private localStorage = inject(LocalStorageService);


  isKucoin() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    if (typeof navigator === 'undefined') {
      return false;
    }
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('kucoin');
  }

  isByBit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    if (typeof navigator === 'undefined') {
      return false;
    }
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('bybit');
  }
}
